import React from "react";
import { connect } from "react-redux";
import { Route, Switch } from "react-router-dom";
import { QuickModalRouter } from "../components/QuickModalRouter";
import {
  AdminDraftOrdersPage,
  AgentsPage,
  CataloguePage,
  CatalogueSettings,
  LoginPage,
  MainPage,
  MyOrdersPage,
  NewOrderPage,
  OrdersPage,
  ResetPasswordPage,
  UsersPage,
} from "../pages";
import Page403 from "../pages/403";
import Page423 from "../pages/423";
import Page500 from "../pages/500";
import { CataloguePageNew } from "../pages/CataloguePageNew";
import { CookiePage } from "../pages/CookiePage";
import HomePage from "../pages/HomePage";
import MaintenancePage from "../pages/MaintenancePage";
import { OrderDetailsPage } from "../pages/OrderDetailsPage";
import { OrderReportPage } from "../pages/OrderReportPage";
import { PrivacyPage } from "../pages/PrivacyPage";
import { jwtDecoder, theme } from "../utils";
import { CataloguePageNewIcon } from "../pages/CataloguePageNewIcon";
import { WishlistPage } from "../pages/WishlistPage";
import { NotifyPage } from "../pages/NotifyPage";
class ModalRouter extends React.Component {
  // is still `/` even though its `/img/2`.
  previousLocation = this.props.location;

  constructor(props) {
    super(props);
    this.state = {
      tokenLoaded: false,
    };
  }

  componentWillUpdate(nextProps) {
    const { location, history } = this.props;
    // set previousLocation if props.location is not modal
    const { pathname } = window.location;
    if (pathname !== "/" && /\/$/.test(pathname)) {
      history.replace(pathname.slice(0, -1));
    }
    if (
      nextProps.history.action !== "POP" &&
      (!location.state || !location.state.modal)
    ) {
      this.previousLocation = this.props.location;
    }
  }

  componentWillMount() {
    document.addEventListener("keydown", this._handleKeyDown.bind(this));
    const { location, dispatch, history } = this.props;
    const params = new URLSearchParams(location.search);
    const { pathname } = window.location;
    if (pathname === "/" || !pathname || pathname === "") {
      history.replace("/");
    }

    const token = sessionStorage.getItem("token");
    const user = token ? jwtDecoder(token.replace("Bearer ", "")) : null;

    if (user) {
      this.setState({
        tokenLoaded: true,
      });
    }
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this._handleKeyDown.bind(this));
  }

  _handleKeyDown(event) {
    const { location, history } = this.props;
    if (
      event.key === "Escape" &&
      location &&
      location.state &&
      location.state.modal &&
      event.target === document.body
    ) {
      history.replace(this.previousLocation);
    }
  }

  render() {
    const { location } = this.props;

    const isModal = !!(
      location.state &&
      location.state.modal &&
      this.previousLocation !== location
    ); // not initial render

    return (
      <div
        id="main.container"
        w={1}
        style={{
          flex: 1,
          WebkitFlex: 1,
          minHeight: "100vh",
          flexDirection: "column",
          backgroundColor: theme.background,
        }}
      >
        <Switch location={isModal ? this.previousLocation : location}>
          <Route path="/orders/:customerId?" component={OrdersPage} />
          <Route path="/orderDetail/:orderId?" component={OrderDetailsPage} />
          <Route path="/orderReport/:orderId?" component={OrderReportPage} />
          <Route path="/resetpassword" component={ResetPasswordPage} />
          <Route path="/users/:agentId?" component={UsersPage} />
          <Route path="/agents" component={AgentsPage} />
          <Route path="/newOrder/:customerId?" component={NewOrderPage} />
          <Route path="/myOrders/:customerId?" component={MyOrdersPage} />
          <Route path="/catalogueSettings" component={CatalogueSettings} />
          <Route path="/adminOrders" component={AdminDraftOrdersPage} />
          <Route path="/catalogue/:orderId" component={CataloguePage} />
          <Route
            path="/cataloguenewicon/:orderId"
            component={CataloguePageNewIcon}
          />
          <Route path="/wishlist" component={WishlistPage} />
          <Route path="/notify" component={NotifyPage} />
          <Route path="/cataloguenew/:orderId" component={CataloguePageNew} />
          <Route path="/main" component={MainPage} />
          <Route path="/privacy" component={PrivacyPage} />
          <Route path="/cookie" component={CookiePage} />
          <Route path="/not-authorized" component={Page403} />
          <Route path="/server-error" component={Page500} />
          <Route path="/login" component={LoginPage} />
          <Route path="/maintenance" component={MaintenancePage} />
          <Route path="/user-locked" component={Page423} />
          <Route path="/" component={LoginPage} />
        </Switch>
        <Route path="/homepage" component={HomePage} />
        <Route path="/users/new/:additionalPar?" component={QuickModalRouter} />
        <Route
          path="/users/edit/:id/:additionalPar?"
          component={QuickModalRouter}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state.system;
  return {
    user,
  };
}

const connectedModalRouter = connect(mapStateToProps)(ModalRouter);
export { connectedModalRouter as ModalRouter };
